import React, { useState, useEffect } from 'react';
import { Swipeable } from 'react-swipeable';
import { onSwipeLeft, onSwipeRight, applyTransition, } from '@nykaa/deals-utils/slider';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import ProgressiveDots from './ProgressiveDots';
import Dots from './dots';
import { CarouselWrapper, SlideSanptogridWrapper, SlidesContainer, SlideWrapper, SnaptogridContainer, IndicatorPosition, LeftArrow, RightArrow, CarouselDesktopbgWrapper, } from './css';
import constants, { eligibleCarouselType } from './constants';
import SectionHeader from '../SectionHeader';
import { FilterChip, Wrapper } from '../CategoryFilters/css';
import IoElement from '../IOElement';
const CarouselV2 = (widgetData) => {
    const { params, children, id, cssStyle, isDesktop, trackingData, isServer, } = widgetData;
    const { delayTimer, carouselType, title, autoScroll, description, bkgColor, positionIndicatorFlag, buttonData, carouselTags, } = params;
    let delayAutoTimer = 0;
    if (autoScroll && autoScroll === 'True') {
        delayAutoTimer = delayTimer === 0 ? 8000 : delayTimer;
    }
    else {
        delayAutoTimer = 0;
    }
    const isShowingIndicator = (positionIndicatorFlag && positionIndicatorFlag === 'on');
    const { buttonWidgetStyle, spacingStyle, positionindicatorStyle, tabsStyle, } = cssStyle;
    const [activeSlide, changeSlide] = useState(0);
    const [intervalState, setIntervalState] = useState(null);
    const slides = children;
    const slidesLength = slides.length;
    const swipeRightHandler = () => {
        changeSlide(onSwipeRight(activeSlide, slidesLength));
        setIntervalState(clearInterval(intervalState));
    };
    const swipeLeftHandler = () => {
        changeSlide(onSwipeLeft(activeSlide, slidesLength));
        setIntervalState(clearInterval(intervalState));
    };
    const rightClickHandler = () => {
        const newSlide = activeSlide + 1;
        if (newSlide < slidesLength) {
            changeSlide(newSlide);
        }
        else {
            changeSlide(0);
        }
    };
    const leftClickHandler = () => {
        const newSlide = activeSlide - 1;
        if (newSlide >= 0) {
            changeSlide(newSlide);
        }
        else {
            changeSlide(slidesLength - 1);
        }
    };
    const clearAutoplay = () => {
        if (!delayAutoTimer) {
            return;
        }
        setIntervalState(clearInterval(intervalState));
    };
    const setAutoplay = () => {
        if (!delayAutoTimer) {
            return;
        }
        const interval = setInterval(() => {
            swipeLeftHandler();
        }, delayAutoTimer);
        setIntervalState(interval);
    };
    /**
     * @description this check added if widgetdata changes in post calls
     * previously without checkout childrens length is not updating into the
     * rerenders.
     */
    useEffect(() => {
        if (slides && slidesLength > 0) {
            clearAutoplay();
            applyTransition(activeSlide, id, cssStyle.spacingStyle.interItem, carouselType);
            setAutoplay();
        }
    }, [activeSlide, slides, slidesLength]);
    const { edgeToEdgeIndicator, snapToGridIndicator, indicator } = positionindicatorStyle;
    const isNewTemplate = !!(edgeToEdgeIndicator || snapToGridIndicator);
    const indicatorType = (templateType, type) => ((templateType === null || templateType === void 0 ? void 0 : templateType.type) === type);
    const edgeToEdgeType = (templateType) => (indicatorType(templateType, constants.PROGRESSIVE)
        || indicatorType(templateType, constants.BAR));
    const isEdgeToEdgeType = (isNewTemplate
        ? edgeToEdgeType(edgeToEdgeIndicator)
        : edgeToEdgeType(indicator));
    const isProgrssiveIndicator = (isNewTemplate
        ? indicatorType(edgeToEdgeIndicator, constants.PROGRESSIVE)
        : indicatorType(indicator, constants.BAR));
    const isButtonWidget = !!(buttonWidgetStyle === null || buttonWidgetStyle === void 0 ? void 0 : buttonWidgetStyle.visible);
    const isTabbedCarousel = !!(carouselType === 'tabbed');
    const isSnapToGrid = !!(carouselType === 'snaptogrid');
    const handleTabImpression = (indx, chip) => ImpressionsHandler.handleImpression(Object.assign(Object.assign({}, trackingData), { button_type: 'tab', button_text: chip, button_position: indx + 1 }));
    /**
     *
     * Required is to keep only V1 impression
     */
    // const handleTabImpressionV2 = (indx: number, chip: string) => ImpressionsHandler.handleImpressionV2({
    //   ...trackingData,
    //   button_type: 'tab',
    //   button_text: chip,
    //   button_position: indx,
    // });
    const handleTabClick = (clickedIndex, text) => {
        ImpressionsHandler.handleClick(Object.assign(Object.assign({}, trackingData), { button_type: 'tab', button_text: text, button_position: clickedIndex + 1 })).then(() => {
            changeSlide(clickedIndex);
        });
    };
    const Indicators = (isType) => (isShowingIndicator && ((isType)
        ? (React.createElement(ProgressiveDots, { length: slidesLength, active: activeSlide, isNewTemplate: isNewTemplate, timer: isProgrssiveIndicator ? delayAutoTimer : 0, onClickHandler: (clickedIndex) => changeSlide(clickedIndex), positionindicatorCss: positionindicatorStyle })) : (React.createElement(Dots, { length: slidesLength, active: activeSlide, onClickHandler: (clickedIndex) => changeSlide(clickedIndex), positionindicatorCss: positionindicatorStyle, isNewTemplate: isNewTemplate }))));
    const emptyCallback = () => '';
    return (React.createElement(CarouselDesktopbgWrapper, { bkgColor: bkgColor, isDesktop: isDesktop },
        React.createElement(CarouselWrapper, { wrapperSpacing: spacingStyle, bkgColor: bkgColor, isDesktop: isDesktop, id: id },
            carouselType === 'edgetoedge' && (React.createElement("div", { className: "swtitleWrapper" },
                React.createElement(SectionHeader, { isDesktop: isDesktop, cssStyle: cssStyle, title: title, description: description, buttonData: buttonData }))),
            (eligibleCarouselType.indexOf(carouselType) > -1) ? (React.createElement("div", { className: carouselType },
                React.createElement("div", { className: "swtitleWrapper" },
                    React.createElement(SectionHeader, { isDesktop: isDesktop, cssStyle: cssStyle, title: title, description: description, buttonData: buttonData }),
                    !isTabbedCarousel && !isButtonWidget && isShowingIndicator && slidesLength > 1 && (React.createElement(IndicatorPosition, { titleCss: cssStyle.descriptionStyle, positionIndicator: positionindicatorStyle, className: "carouselindicator", isNewTemplate: isNewTemplate },
                        ' ',
                        activeSlide + 1,
                        ' ',
                        "of",
                        ' ',
                        slidesLength))),
                isTabbedCarousel && !isDesktop && (React.createElement(Wrapper, { isDesktop: isDesktop, margin: tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.margin, gap: tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.interItem }, carouselTags.map((chip, indx) => {
                    const chipIndex = activeSlide === indx;
                    return (React.createElement("span", { key: `${chip}`, onClick: () => handleTabClick(indx, chip) },
                        React.createElement(IoElement, { isServer: isServer, onIntersect: () => handleTabImpression(indx, chip), onIntersectV2: emptyCallback, exitCallBack: emptyCallback },
                            React.createElement(FilterChip, { bkg: chipIndex
                                    ? tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.selectedStateBkg : tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.unselectedStateBkg, cornerRadius: tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.cornerRadius, border: chipIndex
                                    ? tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.selectedBorder : tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.unselectedBorder, text: chipIndex
                                    ? tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.selectedText : tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.unselectedText, padding: tabsStyle === null || tabsStyle === void 0 ? void 0 : tabsStyle.padding, isDesktop: isDesktop },
                                React.createElement("span", { className: "tabs-text" }, chip)))));
                }))),
                React.createElement(Swipeable, { onSwipedRight: () => swipeRightHandler(), onSwipedLeft: () => swipeLeftHandler(), delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: true, trackMouse: true, rotationAngle: 0, style: { height: '90%', width: '100%' } },
                    React.createElement(SnaptogridContainer, { className: "sliderbannerWrapper", swPadding: cssStyle.spacingStyle.padding, isDesktop: isDesktop },
                        isDesktop && slidesLength > 1 && (React.createElement(LeftArrow, { onClick: leftClickHandler })),
                        isDesktop && slidesLength > 1 && (React.createElement(RightArrow, { onClick: rightClickHandler })),
                        slides.map((slide) => (React.createElement(SlideSanptogridWrapper, { isDesktop: isDesktop, key: id, interItem: cssStyle.spacingStyle.interItem, className: id }, slide))))),
                !isSnapToGrid && Indicators(isEdgeToEdgeType || isTabbedCarousel))) : (React.createElement("div", { className: carouselType },
                React.createElement(Swipeable, { onSwipedRight: () => swipeRightHandler(), onSwipedLeft: () => swipeLeftHandler(), delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: true, trackMouse: true, rotationAngle: 0, style: { height: '90%', width: '100%' } },
                    React.createElement(SlidesContainer, { swPadding: cssStyle.spacingStyle.padding },
                        isDesktop && slidesLength > 1 && (React.createElement(LeftArrow, { onClick: leftClickHandler })),
                        isDesktop && slidesLength > 1 && (React.createElement(RightArrow, { onClick: rightClickHandler })),
                        slides.map((slide) => (React.createElement(SlideWrapper, { className: id }, slide))))),
                !isSnapToGrid && Indicators(isEdgeToEdgeType))))));
};
export default CarouselV2;
